import { Popover as BasePopover } from '@base-ui/react/popover'

import { cn } from '@gto/ui/cn'

export const Popup = ({ className, ...props }: BasePopover.Popup.Props) => {
  return (
    <BasePopover.Popup
      className={cn(
        'relative z-popover rounded-sm bg-paper-elevation4 shadow-9 outline-none',
        // Open / close animation — Base UI marks the popup with `data-starting-style`
        // on mount and `data-ending-style` during teardown; those frames act as the
        // from/to states for the CSS transition that interpolates against the
        // resting (default) values. `--transform-origin` comes from the Positioner.
        'origin-[var(--transform-origin)] transition duration-150 ease-out',
        'data-[starting-style]:scale-95 data-[starting-style]:opacity-0',
        'data-[ending-style]:scale-95 data-[ending-style]:opacity-0',
        className,
      )}
      {...props}
    />
  )
}
